// extracted by mini-css-extract-plugin
export default {"waringMessage":"ieMV15XJCgME_ACR9BP9","link":"L0Ujbgo1nUsh2Tw2kLCl"};